var registEasyDialog = {
    dialogBoxDom: document.querySelector('#regist-dialog'),
    maskDom: document.querySelector('#regist-dialog').querySelector('.mask'),
    dialogDom: document.querySelector('#regist-dialog').querySelector('.container'),
    vueObject: null,

    vueExp: function () {
        //axios 配置
        axios.defaults.crossDomain = true;
        axios.defaults.headers.post['Content-Type'] = 'text/plain; charset=utf-8';
        axios.defaults.baseURL = window.smk_api_host + '/';
        var dialogObj = this;
        this.vueObject = new Vue({
                el: "#vue-regist-dialog",
                data: {
                    isDialogShow: true,
                    dialogStatus: 'regist',
                    isAcqMember: false,
                    sess: '',
                    // 注册表单
                    registForm: {
                        title: '注册',
                        //手机号 验证码 密码 重复密码
                        formList: {
                            userName: {
                                lebal: '手机号',
                                placeholder: '请输入您的手机号',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '手机号输入错误',
                                errorTextEmpty: '请输入您的手机号',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_addTol');
                                }
                            },
                            verifyCode: {
                                lebal: '验证码',
                                placeholder: '请输入验证码',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: /^\d{6}$/,
                                errorText: '',
                                errorTextContent: '你输入的验证码不正确',
                                errorTextEmpty: '请输入验证码',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_addCode');
                                }
                            },
                            password: {
                                lebal: '密码',
                                placeholder: '请输入您的密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: /^[A-Za-z0-9]{8,50}$/,
                                errorText: '',
                                errorTextContent: '密码长度需大于8位',
                                errorTextEmpty: '请输入您的密码',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_addPassword');
                                }
                            },
                            rePassword: {
                                lebal: '确认密码',
                                placeholder: '请再次输入密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '您输入的两次密码不一致',
                                errorTextEmpty: '请再次输入密码',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_confirmPassword');
                                }
                            },
                            ifWish: {
                                lebal: '{$form_PrivacyStatement_text}',
                                placeholder: '',
                                value: '是',
                                type: 'checkbox',
                                checked: false,
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '请选择',
                                errorTextEmpty: '请选择'
                            },
                        },
                        subBtnText: '注册',
                        subBtnDisabled: false,
                        isShowTextBtn: true,
                        textBtnText: '已有账号？去登录'
                    },
                    form: {
                        title: ''
                    },
                    //验证码发送倒计时
                    sendCode: {
                        time: 60,
                        isSending: false,
                        isTimer: false,
                        text: ""
                    },
                    list: [],
                    keyword: '',
                    userInfo: {},
                    loginTimeout:null
                },
                created: function () {
                    this.form = this.registForm;
                },
                methods: {

                    loginSess: function () {
                        return isLogin();
                    },

                    // 文字按钮动作
                    textBtnAction: function () {
                        if(window.location.href.indexOf('/meeting/live.html') > -1){
                            this.clearLogin();
                            setTimeout(function () {
                                registEasyLoginDialog.showDialog();
                            },500);
                            return;
                        }
                        common.gotoLogin();
                    },

                    // 显示登录界面
                    showLogin: function () {
                        this.dialogStatus = 'login';
                    },

                    // 忘记密码
                    forgetPassword: function () {

                    },

                    // 设置登录cookie
                    setLoginCookie: function (userInfo) {
                        setCookie('smarketMember_498', JSON.stringify({
                            session: userInfo.sess,
                            memberId: userInfo.memberId,
                            email: userInfo.info.email
                        }), 30);
                        msg.toast('登录成功！');
                        dialogObj.hideDialog();
                    },

                    regist: function(){
                        var verifyPassword = this.verifyRePassword(this.registForm.formList.password, this.registForm.formList.rePassword);

                        if (!verifyPassword || !this.verifyForm() ||  this.registForm.subBtnDisabled) {
                            console.log('验证不通过')
                            return;
                        }


                        var userName = this.registForm.formList.userName.value;
                        var verifyCode = this.registForm.formList.verifyCode.value;
                        var password = this.registForm.formList.password.value;
                        var ifWish = this.registForm.formList.ifWish.value;

                        this.registForm.subBtnDisabled = true;

                        var info = {
                            'formId': 1430,//表单id
                            'memberSchemaId': '498',//体系id
                            'mobile': userName,//string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
                            'token':  '',//string 第三方登录传 token，token时不需要密码或是动态验证码;
                            'password': (password ? md5(password).toUpperCase() : ''),//string 密码。账号密码的形式必传此项。
                            'checkCode': verifyCode,//string 动态验证码。手机或邮箱动态验证登录传此项
                            'ifWish': ifWish,
                            'backUrl': window.location.href,
                            'url': window.location.href,
                            'getuserinfo':common.getUrlPara('getuserinfo') || '',
                            'browseInfo': client.browseInfo,
                            'globalUserId': common.getCookie('globalUserId') || '',
                            'OCSESSID': common.getCookie('OCSESSID') || ''
                        };
                        if(common.isWx){
                            info.verify = wx_auth.verify || '';
                        }
                        var _this = this;
                        axios.post( solution_host + '/api/account/registerSimple', JSON.stringify(info)).then(function (res) {
                            var data = res.data;
                            if (data.errCode == 0) {
                                _this.setSmarketCookie(data.data.session, data.data.loginId);
                                common.setCookie('OCSESSID', data.data.OCSESSID, 5);
                                gioTrackAction.gio_base('individualRegisterSuccess');
                                msg.toast('注册成功');
                                dialogObj.hideDialog();
                                common.setCookie('light_reg_need_completion', 1);
                                window.location.reload();

                            }else{
                                msg.toast(data.msg);
                            }
                            _this.registForm.subBtnDisabled = false;
                        }).catch(function (error) {
                            console.log(error)
                            _this.registForm.subBtnDisabled = false;
                        })
                    },

                    setSmarketCookie: function(sess, memberId){
                        common.setCookie('smarketMember_'+window.cateData.schemaId, JSON.stringify({
                            session: sess,
                            memberId: memberId
                        }), 5)
                    },

                    sendSms: function () {
                        var userNameVerify = '';
                        var uniqe = '';
                        if (this.dialogStatus == 'regist'){
                            // 注册
                            userNameVerify = this.verify(this.registForm.formList.userName);
                            uniqe = this.registForm.formList.userName.value;
                        }else{
                            userNameVerify = this.verify(this.forgetPasswordForm.formList.userName);
                            uniqe = this.forgetPasswordForm.formList.userName.value;
                        }


                        if (!userNameVerify) {
                            console.log('手机号短信验证失败');
                            return;
                        }

                        if (this.sendCode.isSending) {
                            return;
                        }


                        this.sendCode.isSending = true;
                        this.sendCode.text = '发送中';

                        var info = {
                            unique: uniqe,
                            memberSchemaId: 498,
                            validTime: 600,
                            intervalTime: 60,
                            action: "register",
                            globalUserId: common.getCookie('globalUserId') || '',
                        };

                        var _this = this;
                        this.api('member/sendCheckCode', info).then(
                            function (res) {
                                console.log(res);
                                _this.sendCode.isSending = false;
                                if (res.data.body.result === 0) {

                                    _this.codeTimer();
                                    msg.toast('验证码发送成功！请在10分钟内填写');
                                } else {
                                    if (res.data.body.desc == '唯一标识已存在'){
                                        res.data.body.desc = '您输入的手机号已经注册';
                                    }
                                    msg.toast(res.data.body.desc);
                                }
                            }
                        ).catch(function (error) {
                            _this.sendCode.isSending = false;
                            msg.toast(error.data.msg)
                        });
                    },


                    codeTimer: function () {

                        if (!this.sendCode.isTimer) {
                            this.sendCode.isTimer = true;
                            setTimer();
                        } else {
                            return;
                        }

                        var time = this.sendCode.time;
                        var _this = this;
                        var timer;

                        this.sendCode.text = "等待60秒";

                        function setTimer() {
                            timer = setInterval(function () {
                                if (time > 0) {
                                    time -= 1;
                                    _this.sendCode.text = "等待" + time + "秒";
                                } else {
                                    clearTimer();
                                    _this.sendCode.isTimer = false;
                                }
                            }, 1000);
                        }

                        function clearTimer() {
                            clearInterval(timer)
                        }
                    },

                    // 验证程序
                    verify: function (itemObj) {
                        var flag = true;
                        if (itemObj.isRequired && itemObj.value === '' && itemObj.type !== 'checkbox') {
                            itemObj.isShowError = true;
                            itemObj.errorText = itemObj.errorTextEmpty ? itemObj.errorTextEmpty : '请输入' + itemObj.label;
                            flag = false;
                            return flag;
                        }
                        if (itemObj.isRequired && itemObj.type === 'checkbox' && !itemObj.checked) {
                            itemObj.isShowError = true;
                            itemObj.errorText = itemObj.errorTextEmpty ? itemObj.errorTextEmpty : '请输入' + itemObj.label;
                            flag = false;
                            return flag;
                        }
                        if (itemObj.reg && itemObj.value) {
                            itemObj.isShowError = !itemObj.reg.test(itemObj.value);
                            if (itemObj.isShowError) {
                                itemObj.isShowError = true;
                                itemObj.errorText = itemObj.errorTextContent ? itemObj.errorTextContent : '您输入的' + itemObj.lebal + '错误';
                                flag = false;
                            }
                        }
                        if (flag) {
                            itemObj.isShowError = false;
                            itemObj.errorText = '';
                        }
                        return flag;
                    },

                    // 验证重新输密码
                    verifyRePassword: function (passwordObj, rePasswordObj) {
                        var flag = true;
                        if (passwordObj.value && rePasswordObj.value) {
                            if (passwordObj.value !== rePasswordObj.value) {
                                rePasswordObj.isShowError = true;
                                rePasswordObj.errorText = rePasswordObj.errorTextContent;
                                flag = false;
                            } else {
                                rePasswordObj.isShowError = false;
                                rePasswordObj.errorText = '';
                            }
                        }
                        return flag;
                    },

                    //验证表单
                    verifyForm: function () {
                        var flag = true;
                        for (var item in this.form.formList) {
                            var itemObj = this.form.formList[item];
                            if(this.verify(itemObj) === false){
                                flag = false;
                            }
                        }
                        return flag;
                    },

                    api: function (url, data) {
                        return axios.post(url, JSON.stringify(data))
                    },
                    // 点击已登录跳转，未登录显示登录弹框，
                    windowOpen: function(link){
                        var _this=this;
                        if(isLogin()){
                            window.open(link)
                        }else{
                            clearTimeout(_this.loginTimeout);
                            dialogObj.showDialog();
                        }
                    },
                    // 登录弹框内的关闭按钮
                    clearLogin: function(){
                        dialogObj.iconHideDialog();
                    },
                    
                },
                watch: {

                }
            }
        )
    },
    showDialog: function () {
        this.dialogBoxDom.style.display = 'block';
        this.maskDom.classList.remove('dialog-mask-ani-fade-out');
        this.maskDom.classList.add('dialog-mask-ani-fade-in');

        this.dialogDom = document.querySelector('#regist-dialog').querySelector('.container');
        this.dialogDom.classList.remove('tr-dialog-ani-to-top');
        this.dialogDom.classList.add('tr-dialog-ani-from-top');

        gioTrackAction.gio_base('individualRegisterClick',{
            'individualRegisterEntrancePageTitle': document.title,
            'individualRegisterEntrancePageURL': window.location.href
        })
        gioTrackAction.gio_base('viewIndividualRegister');
        //禁止后方滚动
        setScroll.unScroll();
    },
    hideDialog: function () {
        this.maskDom.classList.remove('dialog-mask-ani-fade-in');
        this.maskDom.classList.add('dialog-mask-ani-fade-out');

        this.dialogDom.classList.remove('tr-dialog-ani-from-top');
        this.dialogDom.classList.add('tr-dialog-ani-to-top');

        var _this = this;
        setTimeout(function () {
            _this.dialogBoxDom.style.display = 'none';
        }, 200);

        //允许后方滚动
        setScroll.removeUnScroll();

    },
    // 点击ico 关闭登录表单
    iconHideDialog: function(){
        this.maskDom.classList.remove('dialog-mask-ani-fade-in');
        this.maskDom.classList.add('dialog-mask-ani-fade-out');

        this.dialogDom.classList.remove('tr-dialog-ani-from-top');
        this.dialogDom.classList.add('tr-dialog-ani-to-top');

        var _this = this;
        setTimeout(function () {
            _this.dialogBoxDom.style.display = 'none';
        }, 200);
        setScroll.removeUnScroll();
    },
    showLoading: function(){
        document.querySelector('.login-dialog-loading').style.display = 'block';
        //禁止后方滚动
        setScroll.unScroll();
    },
    hideLoading: function(){
        document.querySelector('.login-dialog-loading').style.display = 'none';
        //允许后方滚动
        setScroll.removeUnScroll();
    },

    init: function () {
        this.vueExp();
    }
};

registEasyDialog.init();
